<p-breadcrumb *ngIf="viewedBy != AppraisalViewedBy.Hr" [model]="breadcrumb"></p-breadcrumb>

<h1 *ngIf="viewedBy != AppraisalViewedBy.Hr">Employee Appraisal</h1>

<main class="empl-appraisal">
  <div *ngIf="viewedBy != AppraisalViewedBy.Hr" class="instruction-text">Choose from the options below to review and manage employee appraisals.</div>

  <section>
    <div style="padding: 10px; width: 100%; z-index: 5;  background-color: white; height: 40%;">
      <div class="main-section">
        <div style="margin: 0; padding: 0;">
          <div class="searchPanel">
            <div class="p-grid">
              <div class="p-col-12 p-md-6 p-lg-6">
                <div class="p-grid">
                  <div class="p-col-12 p-md-4 p-lg-4">
                    <label>Appraisal Period</label>
                  </div>
                  <div class="p-col-12 p-md-8 p-lg-8">
                    <p-dropdown name="appPeriod" [placeholder]="Validation.DropdownPlaceholder"
                                [options]="appraisalPeriodsDropdown"
                                [(ngModel)]="selectedPeriod"
                                (onChange)="onChangeAppraisalPeriod(selectedPeriod)"></p-dropdown>
                  </div>
                </div>
              </div>
              <div class="p-col-12 p-md-6 p-lg-6">
                <div class="p-grid">
                  <div class="p-col-12 p-md-4 p-lg-4">
                    <label>Manager</label>
                  </div>
                  <div class="p-col-12 p-md-8 p-lg-8">
                    <p-dropdown name="manager" [placeholder]="Validation.DropdownPlaceholder" [showClear]="true" [options]="managersDropdown"
                                [(ngModel)]="selectedManagerId" [filter]="true"></p-dropdown>
                  </div>
                </div>
              </div>
              <div *ngIf="viewedBy == AppraisalViewedBy.Hr" class="p-col-12 p-md-6 p-lg-6">
                <div class="p-grid">
                  <div class="p-col-12 p-md-4 p-lg-4">
                    <label>Department</label>
                  </div>
                  <div class="p-col-12 p-md-8 p-lg-8">
                    <p-dropdown name="department" [placeholder]="Validation.DropdownPlaceholder" [showClear]="true" [options]="obsDropdown"
                                [(ngModel)]="selectedObsId" [filter]="true"></p-dropdown>
                  </div>
                </div>
              </div>
              <div *ngIf="viewedBy == AppraisalViewedBy.Hr" class="p-col-12 p-md-6 p-lg-6">
                <div class="p-grid">
                  <div class="p-col-12 p-md-4 p-lg-4">
                    <label style="white-space: nowrap;font-size:14px;">Signed By Employee</label>
                  </div>
                  <div class="p-col-12 p-md-8 p-lg-8">
                    <p-dropdown name="singedByUser" [placeholder]="Validation.DropdownPlaceholder" [showClear]="true" [options]="signedByUserDropdown"
                                [(ngModel)]="selectedSignedByUser" [filter]="true"></p-dropdown>
                  </div>
                </div>
              </div>
              <div class="p-col-12">
                <div class="p-grid">
                  <div class="p-col-12 p-md-2 p-lg-2"></div>
                  <div class="p-col-12 p-md-2 p-lg-2">
                    <button pButton type="button" class="action-secondary" icon="fa fa-search" label="Go"
                            (click)="searchAppraisals(selectedPeriod?.id, selectedManagerId, selectedObsId, selectedSignedByUser )"></button>
                  </div>
                </div>
              </div>
            </div>
            <div class="main-clear"></div>
          </div>

          <div>
            <button pButton type="button" class="action-secondary" label="Send Overdue Notice"
                    pTooltip="Send Overdue Notice" tooltipPosition="top" style="margin-bottom:15px;background-color:transparent;"
                    (click)="onClickSendOverdueNotice()">
            </button>
          </div>
          <div class="appraisal-table-wrapper">
            <app-data-table [columns]="tableColumns" [value]="appraisalSummaries" dataKey="id" #dt
                            [bodyTemplate]="appraisalBody" [captionTemplate]="appraisalCaption"
                            [headerTemplate]="appraisalHeader" sortField="employeeName">

              <ng-template #appraisalCaption>
                <div class="p-grid">
                  <div class="p-col-12 p-md-4 p-lg-4" style="text-align:left;">

                    <i class="fa fa-search" style="display:inline-block;"></i>
                    <input pInputText type="text" size="20" (input)="dt.table.filterGlobal($event.target.value, 'contains')" placeholder="Table Filter">
                  </div>
                  <div class="p-col-12 p-md-8 p-lg-8" style="text-align:right;">
                    <span style="padding-right:20px;">
                      <label># of Appraisals</label>
                      <span class="appraise-stats">{{appraisalSummaries?.length}}</span>
                    </span>
                    <span style="padding-right:20px;">
                      <label>Employee Signed</label>
                      <span class="appraise-stats">{{ totalSignedByEmployee }}</span>
                    </span>
                    <span style="padding-right:20px;">
                      <label>Manager Signed</label>
                      <span class="appraise-stats">{{ totalSignedByManager }}</span>
                    </span>
                    <span *ngIf="selectedPeriod?.affectsSalary" style="padding-right:20px;">
                      <label>Avg Increase</label>
                      <span class="appraise-stats">{{ avgPercentIncrease / 100 | percent: Format.PercentOneDotTwoDecimal }}</span>
                    </span>
                    <span *ngIf="selectedPeriod?.affectsSalary" style="padding-right:20px;">
                      <label>Total Bonus</label>
                      <span class="appraise-stats">{{ totalBonus | currency: Format.Currency}}</span>
                    </span>
                  </div>
                </div>
              </ng-template>

              <ng-template #appraisalHeader>
                <tr class="appraise-row">
                  <th class="employee-name" pTooltip="Employee Name" tooltipPosition="top" pSortableColumn="employeeName">
                    Employee
                    <p-sortIcon field="'employeeName'"></p-sortIcon>
                  </th>
                  <th class="employee-rating" pTooltip="Employee Rating" tooltipPosition="top" pSortableColumn="overallEmployeeRatingScore">
                    Emp. Rating
                    <p-sortIcon field="'overallEmployeeRatingScore'"></p-sortIcon>
                  </th>
                  <th class="manager-rating" pTooltip="Manager Rating" tooltipPosition="top" pSortableColumn="overallManagerRatingScore">
                    Mgr. Rating
                    <p-sortIcon field="'overallManagerRatingScore'"></p-sortIcon>
                  </th>
                  <th class="position" pTooltip="Current Position" tooltipPosition="top" pSortableColumn="currentPositionTitle">
                    Position
                    <p-sortIcon field="'currentPositionTitle'"></p-sortIcon>
                  </th>
                  <th class="position" pTooltip="Department" tooltipPosition="top" pSortableColumn="employeeObs">
                    Department
                    <p-sortIcon field="'employeeObs'"></p-sortIcon>
                  </th>
                  <th class="current-salary" pTooltip="Current Annual Salary" tooltipPosition="top" pSortableColumn="currentAnnualSalary">
                    Current Salary
                    <p-sortIcon field="'currentAnnualSalary'"></p-sortIcon>
                  </th>
                  <th *ngIf="selectedPeriod?.affectsSalary" class="new-salary" pTooltip="New Annual Salary" tooltipPosition="top"
                      pSortableColumn="newAnnualSalary">
                    New Salary
                    <p-sortIcon field="'newAnnualSalary'"></p-sortIcon>
                  </th>
                  <th class="current-hourly" pTooltip="Current Hourly Salary" tooltipPosition="top" pSortableColumn="currentHourlySalary">
                    Current Hrly
                    <p-sortIcon field="'currentHourlySalary'"></p-sortIcon>
                  </th>
                  <th *ngIf="selectedPeriod?.affectsSalary" class="new-hourly" pTooltip="New Hourly Salary" tooltipPosition="top"
                      pSortableColumn="newHourlySalary">
                    New Hrly
                    <p-sortIcon field="'newHourlySalary'"></p-sortIcon>
                  </th>
                  <th *ngIf="selectedPeriod?.affectsSalary" class="rec-increase" tooltipPosition="top" [escape]="false"
                      [pTooltip]="showSalaryRankTooltip()"
                      pSortableColumn="salaryRank">
                    Rec. Increase
                    <p-sortIcon field="'salaryRank'"></p-sortIcon>
                  </th>
                  <th *ngIf="selectedPeriod?.affectsSalary" class="percent-increase" pTooltip="% Increase" tooltipPosition="top"
                      pSortableColumn="percentIncrease">
                    % Increase
                    <p-sortIcon field="'percentIncrease'"></p-sortIcon>
                  </th>
                  <th *ngIf="selectedPeriod?.affectsSalary" class="amount-increase" pTooltip="Amount Increase" tooltipPosition="top"
                      pSortableColumn="amountIncrease">
                    $ Increase
                    <p-sortIcon field="'amountIncrease'"></p-sortIcon>
                  </th>
                  <th *ngIf="selectedPeriod?.affectsSalary" class="bonus" pSortableColumn="bonus">Bonus
                    <p-sortIcon field="'bonus'"></p-sortIcon>
                  </th>
                  <th class="emp-complete" pTooltip="Signed By Employee" tooltipPosition="top" pSortableColumn="signedByUserOn">
                    Emp.
                    <p-sortIcon field="'signedByUserOn'"></p-sortIcon>
                  </th>
                  <th class="mgr-complete" pTooltip="Signed By Manager" tooltipPosition="top" pSortableColumn="signedByManagerOn">
                    Mgr.
                    <p-sortIcon field="'signedByManagerOn'"></p-sortIcon>
                  </th>
                  <th>Action
                  </th>
                </tr>
              </ng-template>

              <ng-template #appraisalBody let-row="row">
                <tr>
                  <td>
                    <span class="p-column-title">Employee</span>
                    <span class="p-cell">{{row.employeeName}}</span>
                  </td>
                  <td>
                    <span class="p-column-title">Emp. Rating</span>
                    <span class="p-cell">{{row.employeeRatingName}}
                      <div *ngIf="row.employeeRatingScore"> ({{row.employeeRatingScore}})</div>
                    </span>
                  </td>
                  <td>
                    <span class="p-column-title">Mgr. Rating</span>
                    <span class="p-cell">{{row.managerRatingName}}
                      <div *ngIf="row.managerRatingScore"> ({{row.managerRatingScore}})</div>
                    </span>
                  </td>
                  <td>
                    <span class="p-column-title">Position</span>
                    <span class="p-cell">{{row.currentPositionTitle}}
                      <span>
                        <button *ngIf="selectedPeriod?.affectsSalary&&row.currentPositionId!=row.newPositionId" pButton type="button" class="icon-action" icon="fa fa-star"
                                [pTooltip]="'New Position: '+row.newPositionTitle">
                        </button>
                      </span>
                    </span>
                  </td>
                  <td>
                    <span class="p-column-title">Department</span>
                    <span class="p-cell">{{row.employeeObs}}
                    </span>
                  </td>
                  <td>
                    <span class="p-column-title">Current Salary</span>
                    <span class="p-cell">
                      <div [class]="ClassType.CurrencyInTable">{{row.currentAnnualSalary | currency: Format.Currency}}</div>
                    </span>
                  </td>
                  <td *ngIf="selectedPeriod?.affectsSalary">
                    <span class="p-column-title">New Salary</span>
                    <span class="p-cell">
                      <div [class]="ClassType.CurrencyInTable">{{row.newAnnualSalary | currency: Format.Currency}}</div>
                    </span>
                  </td>
                  <td>
                    <span class="p-column-title">Current Hrly</span>
                    <span class="p-cell">
                      <div [class]="ClassType.CurrencyInTable">{{row.currentHourlySalary | currency: Format.Currency}}</div>
                    </span>
                  </td>
                  <td *ngIf="selectedPeriod?.affectsSalary">
                    <span class="p-column-title">New Hrly</span>
                    <span class="p-cell">
                      <div [class]="ClassType.CurrencyInTable">{{row.newHourlySalary | currency: Format.Currency}}</div>
                    </span>
                  </td>
                  <td *ngIf="selectedPeriod?.affectsSalary&&row.recommendedPercentIncrease!=null">
                    <span class="p-column-title" style="float:left;">Rec. Increase</span>
                    <span class="p-cell">
                      <div [class]="ClassType.CurrencyInTable">{{row.salaryRank}} /
                        {{row.recommendedPercentIncrease}}%
                      </div>
                    </span>
                  </td>
                  <td *ngIf="selectedPeriod?.affectsSalary&&row.recommendedPercentIncrease==null" style="text-align:center;">
                    <span class="p-column-title" style="float:left;">Rec. Increase</span>
                    <span class="p-cell">{{row.salaryRank}}</span>
                  </td>
                  <td *ngIf="selectedPeriod?.affectsSalary">
                    <span class="p-column-title">% Increase</span>
                    <span class="p-cell">
                      <div [class]="ClassType.CurrencyInTable">{{row.percentIncrease}}%</div>
                    </span>
                  </td>
                  <td *ngIf="selectedPeriod?.affectsSalary">
                    <span class="p-column-title">$ Increase</span>
                    <span class="p-cell">
                      <div [class]="ClassType.CurrencyInTable">{{row.amountIncrease | currency: Format.Currency}}</div>
                    </span>
                  </td>
                  <td *ngIf="selectedPeriod?.affectsSalary">
                    <span class="p-column-title">Bonus</span>
                    <span class="p-cell">
                      <div [class]="ClassType.CurrencyInTable">{{row.bonus | currency: Format.Currency}}</div>
                    </span>
                  </td>
                  <td style="text-align:center;">
                    <span class="p-column-title" style="float:left;">Emp.</span>
                    <span class="p-cell">
                      <p-checkbox name="employeeSigned" [disabled]="true" [ngModel]="row.signedByUser" binary="true"></p-checkbox>
                    </span>
                  </td>
                  <td style="text-align:center;">
                    <span class="p-column-title" style="float:left;">Mgr.</span>
                    <span class="p-cell">
                      <p-checkbox name="managerSigned" [disabled]="true" [ngModel]="row.signedByManager" binary="true"></p-checkbox>
                    </span>
                  </td>
                  <td>
                    <span class="p-column-title">Actions</span>
                    <span class="p-cell">
                      <!-- <a> tags need to not have line feeds in them, or primeng remders them as an underscore -->
                      <a routerLink="./../../ess/self-appraisal/{{row.id}}/HR">
                        <button *ngIf="viewedBy == AppraisalViewedBy.Hr" pButton type="button" class="icon-action" icon="fa fa-eye" pTooltip="View Assessment for HR"
                                tooltipPosition="top"></button>
                      </a>
                      <a routerLink="./../../ess/self-appraisal/{{row.id}}/MANAGER">
                        <button *ngIf="viewedBy == AppraisalViewedBy.Manager && row.managerId == userId && row.signedByManagerOn" pButton type="button" class="icon-action" icon="fa fa-eye"
                                pTooltip="View Assessment for Manager"
                                tooltipPosition="top"></button>
                      </a>
                      <a routerLink="./../../ess/self-appraisal/{{row.id}}/MANAGER">
                        <button *ngIf="viewedBy == AppraisalViewedBy.Manager && row.managerId == userId && !row.signedByManagerOn &&
                            selectedPeriod?.appraisalStatus == AppraisalStatus.OPEN" pButton type="button" class="icon-action" icon="fa fa-pencil" pTooltip="Perform Assessment for Manager"
                                tooltipPosition="top"></button>
                      </a>

                      <button *ngIf="selectedPeriod?.affectsSalary" pButton type="button" class="icon-action" icon="fa fa-dollar" pTooltip="Edit Salary/Bonus"
                              tooltipPosition="top"
                              (click)="onClickNewAppraisalLog(row)"
                              [disabled]="selectedPeriod?.appraisalStatus == AppraisalStatus.CLOSED || !row.signedByManager"></button>

                      <button *ngIf="selectedPeriod?.affectsSalary" pButton type="button" class="icon-action" icon="fa fa-external-link"
                              pTooltip="Show Salary/Bonus Change(s)" tooltipPosition="top"
                              (click)="onClickShowAppraisalLog(row, $event, appraisalLogOverlayPanel)"
                              [disabled]="!row.signedByManager"
                              aria-hidden="true"></button>
                    </span>
                  </td>
                </tr>
              </ng-template>

            </app-data-table>
          </div>

          <p-dialog *ngIf="selectedAppraisalSummary&&appraisalLog&&appraisalLogDialog" [(visible)]="appraisalLogDialog" header="Update Position & Compensation" [dismissableMask]="true" [responsive]="true"
                    [modal]="true" [style]="PrimeNgConfig.DialogStyle40">
            <form #updateForm="ngForm">
              <div class="p-grid">
                <div class="p-col-12 p-md-4 p-lg-4">
                  <label>Employee</label>
                </div>
                <div class="p-col-12 p-md-8 p-lg-8">
                  {{selectedAppraisalSummary.employeeName}}
                </div>
              </div>

              <div class="p-grid">
                <div class="p-col-12 p-md-4 p-lg-4">
                  <label>Current Position</label>
                </div>
                <div class="p-col-12 p-md-8 p-lg-8">
                  {{selectedAppraisalSummary.currentPositionTitle}}
                </div>
              </div>

              <div *ngIf="selectedAppraisalSummary.flsaType == FlsaType.Exempt" class="p-grid">
                <div class="p-col-12 p-md-4 p-lg-4">
                  <label>Current Annual Salary</label>
                </div>
                <div class="p-col-12 p-md-8 p-lg-8">
                  {{selectedAppraisalSummary.currentAnnualSalary | currency: Format.Currency}}
                </div>
              </div>

              <div *ngIf="selectedAppraisalSummary.flsaType == FlsaType.NonExempt" class="p-grid">
                <div class="p-col-12 p-md-4 p-lg-4">
                  <label>Current Hourly Salary</label>
                </div>
                <div class="p-col-12 p-md-8 p-lg-8">
                  {{selectedAppraisalSummary.currentHourlySalary | currency: Format.Currency}}
                </div>
              </div>

              <div class="p-grid">
                <div class="p-col-12 p-md-4 p-lg-4">
                  <label>Manager Rating</label>
                </div>
                <div class="p-col-12 p-md-8 p-lg-8">
                  {{selectedAppraisalSummary.managerRatingName}} ({{selectedAppraisalSummary.managerRatingScore}})
                </div>
              </div>

              <div *ngIf="selectedAppraisalSummary.flsaType == FlsaType.Exempt" class="p-grid">
                <div class="p-col-12 p-md-4 p-lg-4">
                  <label>Quartile and Salary Recommendation</label>
                </div>
                <div *ngIf="selectedAppraisalSummary.recommendedPercentIncrease!=null" class="p-col-12 p-md-8 p-lg-8">
                  {{selectedAppraisalSummary.salaryRank}} / {{selectedAppraisalSummary.recommendedPercentIncrease}}%
                  ({{selectedAppraisalSummary.recommendedPercentIncrease * selectedAppraisalSummary.currentAnnualSalary / 100 | currency: Format.Currency}})
                </div>
                <div *ngIf="selectedAppraisalSummary.recommendedPercentIncrease==null" class="p-col-12 p-md-8 p-lg-8">
                  {{selectedAppraisalSummary.salaryRank}}
                </div>
              </div>

              <div *ngIf="selectedAppraisalSummary.flsaType == FlsaType.NonExempt" class="p-grid">
                <div class="p-col-12 p-md-4 p-lg-4">
                  <label>Quartile and Salary Recommendation</label>
                </div>
                <div *ngIf="selectedAppraisalSummary.recommendedPercentIncrease!=null" class="p-col-12 p-md-8 p-lg-8">
                  {{selectedAppraisalSummary.salaryRank}} / {{selectedAppraisalSummary.recommendedPercentIncrease}}%
                  ({{selectedAppraisalSummary.recommendedPercentIncrease * selectedAppraisalSummary.currentHourlySalary / 100 | currency: Format.Currency}})
                </div>
                <div *ngIf="selectedAppraisalSummary.recommendedPercentIncrease==null" class="p-col-12 p-md-8 p-lg-8">
                  {{selectedAppraisalSummary.salaryRank}}
                </div>
              </div>

              <div class="p-grid">
                <div class="p-col-12 p-md-4 p-lg-4">
                  <label>New Position</label>
                </div>
                <div class="p-col-12 p-md-8 p-lg-8">
                  <p-dropdown name="posDescId" [placeholder]="Validation.DropdownPlaceholder" [options]="positionDropdown"
                              [(ngModel)]="appraisalLog.positionId" (onChange)="onChangePosition(appraisalLog)"
                              [filter]="true"></p-dropdown>
                </div>
              </div>

              <div class="p-grid">
                <div class="p-col-12 p-md-4 p-lg-4">
                  <label>Percent Increase</label>
                </div>
                <div class="p-col-12 p-md-8 p-lg-8">
                  <input pInputText name="percentIncrease" type="number" [(ngModel)]="appraisalLog.percentIncrease"/>
                </div>
              </div>

              <div class="p-grid">
                <div class="p-col-12 p-md-4 p-lg-4">
                  <label>Bonus</label>
                </div>
                <div class="p-col-12 p-md-8 p-lg-8">
                  <input pInputText name="bonus" type="number" [(ngModel)]="appraisalLog.bonus"/>
                </div>
              </div>
            </form>

            <p-footer>
              <div style="text-align:right;">
                <button pButton type="button" class="button-inaction" icon="fa fa-close" label="Cancel"
                        (click)="appraisalLogDialog=false"></button>
                <button pButton type="button" class="button-action" icon="fa fa-check" label="Save"
                        (click)="saveAppraisalLog(appraisalLog)" [disabled]="updateForm.invalid"></button>
              </div>
            </p-footer>
          </p-dialog>

          <p-overlayPanel #appraisalLogOverlayPanel [dismissable]="true" [showCloseIcon]="true" appendTo="body"
                          [style]="PrimeNgConfig.DialogStyle90">
            <div style="font-weight:bold;text-align:center;margin-bottom:15px;">
              Position & Compensation Change(s) for {{selectedAppraisalSummary?.employeeName}}
            </div>

            <div class="p-grid">
              <div class="p-col-12 p-md-6 p-lg-6">
                <div class="p-grid">
                <div class="p-col-12 p-md-6 p-lg-6">
                  <label>Current Position</label>
                </div>
                <div class="p-col-12 p-md-6 p-lg-6">
                  {{selectedAppraisalSummary?.currentPositionTitle}}
                </div>
                </div>
              </div>
              <div *ngIf="selectedAppraisalSummary?.flsaType == FlsaType.Exempt" class="p-col-12 p-md-6 p-lg-6">
                <div class="p-grid">
                <div class="p-col-12 p-md-6 p-lg-6">
                  <label>Current Annual Salary</label>
                </div>
                <div class="p-col-12 p-md-6 p-lg-6">
                  {{selectedAppraisalSummary.currentAnnualSalary | currency:Format.Currency}}
                </div>
                </div>
              </div>
              <div *ngIf="selectedAppraisalSummary?.flsaType == FlsaType.NonExempt" class="p-col-12 p-md-6 p-lg-6">
                <div class="p-grid">
                <div class="p-col-12 p-md-6 p-lg-6">
                  <label>Current Hourly Salary</label>
                </div>
                <div class="p-col-12 p-md-6 p-lg-6">
                  {{selectedAppraisalSummary?.currentHourlySalary | currency:Format.Currency}}
                </div>
                </div>
              </div>
            </div>

            <app-data-table [columns]="logsTableColumns" [value]="appraisalLogs" dataKey="id" [style]="{'width': '100%'}"
                            sortField="updatedOn">
            </app-data-table>
          </p-overlayPanel>

          <p-confirmDialog></p-confirmDialog>

        </div>
      </div>
    </div>
  </section>

</main>
